import { Group, Rating, Text } from '@mantine/core';

// Read-only star display for review aggregates (contract §4.10).
//
// - `value` — rating_avg (number | null). Renders nothing when null/undefined,
//   matching "unrated" sellers.
// - `count` — optional rating_count; shown as "(N)" after the stars.
// - Uses Mantine's Rating (readOnly, half-star fractions) — no hand-rolled stars.
const RatingStars = ({ value, count, size = 'sm' }) => {
  if (value == null) return null;

  return (
    <Group gap={6} wrap="nowrap" aria-label={`Rated ${value} out of 5`}>
      <Rating value={value} fractions={2} readOnly size={size} color="yellow" />
      {count != null && (
        <Text size="sm" c="dimmed">({count})</Text>
      )}
    </Group>
  );
};

export default RatingStars;
